import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { UncontrolledTooltip } from 'reactstrap';
import { useIntl } from 'react-intl';

import { showModal } from '../../actions';
import { userCan } from '../../helpers/Auth';
import {
  getFileAccessIcon,
  getFileAccessText,
} from '../../helpers/Files';
import { getSetting } from '../../helpers/Settings';

const CollectionsAccess = ({
  collection,
  inModal,
  handleChangeAccess,
}) => {
  const intl = useIntl();

  return (
    <span className="collection-access">
      {(userCan('collection.change_access', collection) && !inModal) ? (
        <a
          href="#access"
          onClick={(e) => {
            e.preventDefault();
            handleChangeAccess(collection.uuid);
          }}
          aria-label={intl.formatMessage({ defaultMessage: 'Change access' })}
        >
          <i className={`fas ${getFileAccessIcon(collection)}`} id={`CollectionAccessTooltip-${collection.uuid}${inModal ? '-m' : ''}`} />
        </a>
      ) : (
        <span>
          <i className={`fas ${getFileAccessIcon(collection)}`} id={`CollectionAccessTooltip-${collection.uuid}${inModal ? '-m' : ''}`} />
        </span>
      )}
      {(!getSetting('cs1') || inModal) && (
        <UncontrolledTooltip fade={false} placement="bottom" target={`CollectionAccessTooltip-${collection.uuid}${inModal ? '-m' : ''}`}>
          {getFileAccessText(collection, intl)}
        </UncontrolledTooltip>
      )}
    </span>
  );
};

const mapDispatchToProps = dispatch => ({
  handleChangeAccess: (collection) => {
    dispatch(showModal('AccessModal', {
      className: 'modal-access modal-file-access',
      collections: [collection],
    }));
  },
});

CollectionsAccess.propTypes = {
  collection: PropTypes.object.isRequired,
  inModal: PropTypes.bool,
  handleChangeAccess: PropTypes.func.isRequired,
};

CollectionsAccess.defaultProps = {
  inModal: false,
};

export default connect(null, mapDispatchToProps)(CollectionsAccess);
